import { gql } from "apollo-boost";

export const GET_CATEGORY = gql`
  query allCategory($catId: Int, $catName: String) {
    allCategory(catId: $catId, catName: $catName) {
      edges {
        node {
          catId
          catName
          catDesc
          catType
        }
      }
    }
  }
`;

export const GET_CATEGORY_VALUE = gql`
  query allCategoryValue(
    $catId: Int
    $catName: String
    $valId: Int
    $valName: String
  ) {
    allCategoryValue(
      catId: $catId
      catName: $catName
      valId: $valId
      valName: $valName
    ) {
      edges {
        node {
          valId
          valName
          valNameRus
          valDesc
          valDescRus
          obsolete
          catId
          category {
            catName
          }
        }
      }
    }
  }
`;
